import * as React from 'react';

import Activity20 from './Activity20';

export const activity20 = () => <Activity20 />;

export default {
    title: 'Icon/Fill/Activity20',
    component: Activity20,
    parameters: {
        notes: "`import Activity20 from 'box-ui-elements/es/icon/fill/Activity20';`",
    },
};
